import { useParams } from "react-router-dom"
import ExchangeRatesTable from "routes/Base/Admin/ExchangeRates"

export default function AgencyClientExchangeRates() {
  const { id } = useParams<{ id: string }>()
  return <ExchangeRatesTable clientId={id} />
}
